import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Avatar } from '../atoms/Avatar'
import { TimePicker } from '../atoms/TimePicker'
import { TableRow } from './Table'
import styled from 'styled-components'
import { spacing } from '../theme'

const Label = styled.label`
   display: flex;
   align-items: center;
   margin: ${spacing.sm} 0;

   ${props => (props.isDisabled ? `opacity: .5;` : '')}

   & > div {
      margin: 0 ${spacing.sm};
   }
`

const InputWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
`

const TimePickerPlaceholder = styled.span`
   &:before {
      content: '-';
   }
`

export const ChildWithDefaultHours = ({
   child,
   dropOff,
   pickUp,
   onChange,
   isDisabled
}) => {
   const [dropOffTime, setDropOffTime] = useState(dropOff)
   const [pickUpTime, setPickUpTime] = useState(pickUp)

   useEffect(() => {
      const data = {
         child: child,
         dropOff: dropOffTime,
         pickUp: pickUpTime
      }

      if (typeof onChange === 'function' && data) {
         onChange(data)
      }
   }, [pickUpTime, dropOffTime, child])

   return (
      <TableRow>
         <Label isDisabled={isDisabled}>
            <Avatar
               size={'medium'}
               name={child.name}
               childOrder={child.childOrder}
            />
            <span>{child.name}</span>
         </Label>
         <InputWrapper>
            {!isDisabled ? (
               <TimePicker
                  pickedTime={dropOffTime}
                  startTime={'07:30'}
                  endTime={'14:00'}
                  onChange={e => {
                     setDropOffTime(e)
                  }}
               />
            ) : (
               <TimePickerPlaceholder />
            )}
         </InputWrapper>
         <InputWrapper>
            {!isDisabled ? (
               <TimePicker
                  pickedTime={pickUpTime}
                  startTime={dropOffTime ? dropOffTime : '11:00'}
                  endTime={'17:30'}
                  onChange={e => {
                     setPickUpTime(e)
                  }}
               />
            ) : (
               <TimePickerPlaceholder />
            )}
         </InputWrapper>
      </TableRow>
   )
}

ChildWithDefaultHours.propTypes = {
   /**
    * Child data
    */
   child: PropTypes.object.isRequired,
   /**
    * Drop off time, string '07:00'
    */
   dropOff: PropTypes.string,
   /**
    * Pick up time, string '15:00'
    */
   pickUp: PropTypes.string,
   /**
    * Input Disabled
    */
   isDisabled: PropTypes.bool,
   /**
    * Function when child status is changed
    */
   onChange: PropTypes.func
}

ChildWithDefaultHours.defaultProps = {
   child: {},
   dropOff: '-',
   pickUp: '-',
   isDisabled: false,
   onChange: e => {
      console.log('Change values', e)
   }
}
